module.exports = __webpack_public_path__ + "static/media/speaker1.e37faf4c.jpg";